import { css } from 'styled-components';
export const SuggestionListStyle = css`
  color: #434447;
  top: calc(100% + 2px);
  text-align: left;
  border-radius: 4px;
  display: block;
  width: 100%;
  position: absolute;
  z-index: 10000;
  background: #fff;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);
  :3: ;
`;

export const InputStyle = css`
  border-radius: 4px;
  line-height: 24px;
  font-size: 20px;
  padding: 17px 0;
  width: 100%;
  margin: 0;
  color: #2f3034;
  border-radius: 4px;
  padding-left: 40px;
  ::-webkit-input-placeholder {
    font-size: 16px;
    @media (max-width: ${props => props.theme.breakpoints.sm}rem) {
      font-size: 13px;
    }
  }
`;
